// common functions used in the UI components rules for validation
// each function will either return ture which means the value is valid or the
// error message that need to be displayed.
// each function will take the following params
// value: the value of the field that needs to be validated
// name: the field name, which will be used in the validation error message

import {
    isEmail,
    isUrl,
    isPhone,
    isNumeric,
    isAlphaNumericDash,
    isZipCode,
    isMacAddress
} from '@/common/helpers';
import appFeatures from '@/appFeatures';

export const checkRequired = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} is required`;
    return !!value || defaultMessage;
};

export const checkMaxLength = (value, maxLength, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be at most ${maxLength} characters long`;
    return !value || value.length <= maxLength || defaultMessage;
};

export const checkMinLength = (value, minLength, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be at least ${minLength} characters long`;
    return (!!value && value.length >= minLength) || defaultMessage;
};

export const checkEmail = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid email for ex: john.doe@domain.com`;
    return !value || isEmail(value) || defaultMessage;
};

export const checkUrl = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid URL for ex: http://www.comcast.com`;
    return !value || isUrl(value) || defaultMessage;
};

// The country field is missing from the API now. Once we add it, we can pass it to this function.
// In the meantime, validation will return true if the country code is missing.
export const checkPhone = (value, name, country) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid phone number for ex: (212) 433-3443`;
    return !value || !country || isPhone(value) || defaultMessage;
};

// The country field is missing from the API now. Once we add it, we can pass it to this function.
// In the meantime, validation will return true if the country code is missing.
export const checkZipCode = (value, name, country) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid zip code ex: 19145`;
    return !value || !country || isZipCode(value, country) || defaultMessage;
};

export const checkNumeric = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid number`;
    return !value || isNumeric(value) || defaultMessage;
};

export const checkSameAs = (value, equalToValue, name, equalToName) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be same as ${equalToName}`;
    return value === equalToValue || defaultMessage;
};

export const checkMacAddress = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} should be a valid mac address. 6 pairs of characters between 0-9 and A-F`;
    return !value || isMacAddress(value) || defaultMessage;
};

export const checkUsername = (value, name, partner) => {
    const allowedPartners = appFeatures['allowedMsos'];
    const fieldName = name || 'field';
    let defaultMessage;
    if (allowedPartners.includes(partner)) {
        switch (partner) {
            case 'cox':
                defaultMessage = `${fieldName} should be a valid email for ex: john.doe@domain.com`;
                return !value || isEmail(value) || defaultMessage;
            default:
                defaultMessage = `${fieldName} should be a valid username. Can only contains letters a-z,A-Z and numbers 0-9`;
                return !value || isAlphaNumericDash(value) || defaultMessage;
        }
    } else {
        defaultMessage = `${fieldName} should be a valid username. Make sure you select a valid partner`;
        return !value || defaultMessage;
    }
};

export const checkAlphaNumericOrDash = (value, name) => {
    const fieldName = name || 'field';
    const defaultMessage = `${fieldName} can only contains letters a-z,A-Z, numbers 0-9, spaces, dashes, or underscores`;
    return !value || isAlphaNumericDash(value) || defaultMessage;
};
